import React from "react";
import linkedInIcon from "../public/linkedin-logo.png";
import githubIcon from "../public/github-mark.png"
import "../styles/footer.scss";

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="row">
        <a className="iconLink" href="https://www.linkedin.com/in/youfoundzoe/" target="_blank" rel="noopener noreferrer">
          <img className="footer-img" src={linkedInIcon} alt="LinkedIn" />
        </a>
        <a className="iconLink" href="https://github.com/crimsonRIBBON" target="_blank" rel="noopener noreferrer">
          <img className="footer-img" src={githubIcon} alt="GitHub" />
        </a>
      </div>
      <p>Zoe Donovan 2026</p>
    </footer>
  );
};

export default Footer;
